import React from 'react';
import * as styles from './CarouselCianLayout.css';

interface ICarouselPhotoProps {
  src: string;
}

const CarouselCianLayoutComponent: React.FC<ICarouselPhotoProps> = ({ src }) => (
  <div className={styles['container']}>
    <div className={styles['title']}>Типовая планировка квартиры от Циан</div>
    <div className={styles['layout']} style={{ backgroundImage: `url(${src})` }} />
  </div>
);

export const CarouselCianLayout = React.memo(CarouselCianLayoutComponent);
